export default __webpack_public_path__ + "static/media/reward-title-en.f65c718b.svg";